export default __webpack_public_path__ + "static/media/mentors.12191f2a.png";